import { Accordions } from './Accordions';
import { ArticleFooterActions } from './ArticleFooterActions';
import { ArticleHeaderHeading } from './ArticleHeaderHeading';
import { ArticleHeaderImage } from './ArticleHeaderImage';
import { ArticleSidebarNewsletter } from './ArticleSidebarNewsletter';
import { BlogGrid } from './BlogGrid';
import { BlogNavigation } from './BlogNavigation';
import { ComparePlans } from './ComparePlans';
import { ContactForm } from './ContactForm';
import { EmailSignup } from './EmailSignup';
import { FeatureAccordion } from './FeatureAccordion';
import { FeatureCarousel } from './FeatureCarousel';
import { FeatureEmailSignup } from './FeatureEmailSignup';
import { FeatureGallery } from './FeatureGallery';
import { FeatureGrid } from './FeatureGrid';
import { FeatureHalfHero } from './FeatureHalfHero';
import { FeatureImage } from './FeatureImage';
import { FeatureImageInsights } from './FeatureImageInsights';
import { FeatureSteps } from './FeatureSteps';
import { FeatureTabs } from './FeatureTabs';
import { FeatureTimeline } from './FeatureTimeline';
import { FeaturedArticle } from './FeaturedArticle';
import { GridSteps } from './GridSteps';
import { HeroCarousel } from './HeroCarousel';
import { HighlightedSlides } from './HighlightedSlides';
import { HoverCards } from './HoverCards';
import { Html } from './Html';
import { Image } from './Image';
import { ImageQuote } from './ImageQuote';
import { LogoMarquee } from './LogoMarquee';
import { LogoMarqueeV2 } from './LogoMarqueeV2';
import { MainHero } from './MainHero';
import { MainHeroV2 } from './MainHeroV2';
import { Markdown } from './Markdown';
import { Media } from './Media';
import { Metrics } from './Metrics';
import { PlanHero } from './PlanHero';
import { ProductCard } from './ProductCard';
import { Quote } from './Quote';
import { SimplePageHeader } from './SimplePageHeader';
import { TestimonialBlock } from './TestimonialBlock';
import { TestimonialCarousel } from './TestimonialCarousel';
import { TestimonialMasonry } from './TestimonialMasonry';
import { TextHeading } from './TextHeading';
import { TwoCards } from './TwoCards';
import { TwoColumnText } from './TwoColumnText';
import { ValueLogos } from './ValueLogos';
import { ValueProps } from './ValueProps';
import { VideoHero } from './VideoHero';

export default [
  Accordions,
  ArticleFooterActions,
  ArticleHeaderHeading,
  ArticleHeaderImage,
  ArticleSidebarNewsletter,
  BlogGrid,
  BlogNavigation,
  ComparePlans,
  ContactForm,
  EmailSignup,
  FeatureAccordion,
  FeatureCarousel,
  FeatureEmailSignup,
  FeatureGallery,
  FeatureGrid,
  FeatureHalfHero,
  FeatureImage,
  FeatureImageInsights,
  FeatureSteps,
  FeatureTabs,
  FeatureTimeline,
  FeaturedArticle,
  GridSteps,
  HeroCarousel,
  HighlightedSlides,
  HoverCards,
  Html,
  Image,
  ImageQuote,
  LogoMarquee,
  LogoMarqueeV2,
  MainHero,
  MainHeroV2,
  Markdown,
  Media,
  Metrics,
  PlanHero,
  ProductCard,
  Quote,
  SimplePageHeader,
  TestimonialBlock,
  TestimonialCarousel,
  TestimonialMasonry,
  TextHeading,
  TwoCards,
  TwoColumnText,
  ValueLogos,
  ValueProps,
  VideoHero,
];
